<template>
  <SeoPage page-key="agenziaSeoTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'AgenziaSeoTicinoPage'
})
</script>

